import React from 'react'
import { Box, MenuItem, TextField, Checkbox, ListItemText } from '@mui/material'
import useIsAdmin from '../../hooks/useIsAdmin'

const Filters = ({ filters, setFilters, lists, loadingStates }) => {
  const { taskTypes, taskStatusTypes, identities } = lists
  const { taskStatusTypeIds, taskTypeIds, identityIds, startDate, endDate } =
    filters
  const { statusTypesLoading, identitiesLoading, taskTypesLoading } =
    loadingStates

  const updateFilters = (key, value) => {
    setFilters({ ...filters, [key]: value })
  }

  const { isPriveledged } = useIsAdmin()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f0f0f0',
        mr: 1,
        padding: 2,
        width: '300px',
      }}
    >
      {!taskTypesLoading && (
        <TextField
          margin='dense'
          label={'Task'}
          select
          SelectProps={{
            multiple: true,
            renderValue: (selected) =>
              selected
                .map((s) => taskTypes.find((tt) => tt.id === s).name)
                .join(', '),
          }}
          value={taskTypeIds}
          onChange={(e) => updateFilters('taskTypeIds', e.target.value)}
          InputProps={{ sx: { background: 'white' } }}
        >
          {taskTypes.map((tt) => (
            <MenuItem key={tt.id} value={tt.id}>
              <Checkbox checked={taskTypeIds.indexOf(tt.id) > -1} />
              <ListItemText>{tt.name}</ListItemText>
            </MenuItem>
          ))}
        </TextField>
      )}

      {!statusTypesLoading && (
        <TextField
          margin='dense'
          label={'Task Status'}
          select
          SelectProps={{
            multiple: true,
            renderValue: (selected) =>
              selected
                .map((s) => taskStatusTypes.find((tst) => tst.id === s).name)
                .join(', '),
          }}
          value={taskStatusTypeIds}
          onChange={(e) => updateFilters('taskStatusTypeIds', e.target.value)}
          InputProps={{ sx: { background: 'white' } }}
        >
          {taskStatusTypes.map((tst) => (
            <MenuItem key={tst.id} value={tst.id}>
              <Checkbox checked={taskStatusTypeIds.indexOf(tst.id) > -1} />
              <ListItemText>{tst.name}</ListItemText>
            </MenuItem>
          ))}
        </TextField>
      )}

      {!identitiesLoading && (
        <TextField
          margin='dense'
          label={'Users'}
          select
          disabled={isPriveledged}
          SelectProps={{
            multiple: true,
            renderValue: (selected) =>
              selected
                .map((s) => {
                  const { firstName, lastName } = identities.find(
                    (i) => i.id === s
                  )
                  return `${firstName} ${lastName}`
                })
                .join(', '),
          }}
          value={identityIds}
          onChange={(e) => setIdentityIds(e.target.value)}
          InputProps={{ sx: { background: 'white' } }}
        >
          {identities.map((i) => (
            <MenuItem key={i.id} value={i.id}>
              <Checkbox checked={identityIds.indexOf(i.id) > -1} />
              <ListItemText>
                {i.firstName} {i.lastName}
              </ListItemText>
            </MenuItem>
          ))}
        </TextField>
      )}

      <TextField
        margin='dense'
        label={'Start'}
        type={'date'}
        InputLabelProps={{
          shrink: true,
        }}
        value={startDate}
        onChange={(e) => {
          updateFilters('startDate', e.target.value)
        }}
        InputProps={{ sx: { background: 'white' } }}
      />
      <TextField
        margin='dense'
        label={'End'}
        type={'date'}
        InputLabelProps={{
          shrink: true,
        }}
        value={endDate}
        onChange={(e) => {
          updateFilters('endDate', e.target.value)
        }}
        InputProps={{ sx: { background: 'white' } }}
      />
    </Box>
  )
}

export default Filters
